/**
 * Sets up the basic environment for running Perseus in.
 */

window.icu = {
    getDecimalFormatSymbols: function getDecimalFormatSymbols() {
        return {
            decimal_separator: ".",
            grouping_separator: ",",
            minus: "-"
        };
    }
};

window.KhanUtil = {
    debugLog: function debugLog() {},
    localeToFixed: function localeToFixed(num, precision) {
        return num.toFixed(precision);
    }
};

window.Exercises = {
    localMode: true,

    useKatex: true,
    khanExercisesUrlBase: "../",

    getCurrentFramework: function getCurrentFramework() {
        return "khan-exercises";
    },
    PerseusBridge: {
        cleanupProblem: function cleanupProblem() {
            return false;
        }
    }
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/perseus-env.js
 ** module id = 1
 ** module chunks = 0 2
 **/